exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".request-card {\n  display: flex;\n  flex-direction: column;\n  margin: 16px;\n  background-color: #ffffff;\n  border: 1px solid #dbdbdb;\n  padding: 16px;\n  color: #000000;\n  font-size: 18px;\n  font-weight: 400;\n}\n.request-card__status--fail {\n  cursor: pointer;\n}\n.request-card__desc {\n  display: flex;\n  justify-content: space-between;\n}\n.request-card__meta {\n  display: flex;\n}\n.request-card__region {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 8px 8px 0;\n}\n.request-card__collections {\n  font-size: 16px;\n}\n.request-card__date {\n  letter-spacing: 1.8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Requests/components/Request/Request.less
// module id = 1173
// module chunks = 0